var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.28906 7.78193V17.5119C2.28906 19.4119 3.63906 20.1919 5.27906 19.2519L7.62906 17.9119C8.13906 17.6219 8.98906 17.5919 9.51906 17.8619L14.7691 20.4919C15.2991 20.7519 16.1491 20.7319 16.6591 20.4419L20.9891 17.9619C21.5391 17.6419 21.9991 16.8619 21.9991 16.2219V6.49193C21.9991 4.59193 20.6491 3.81193 19.0091 4.75193L16.6591 6.09193C16.1491 6.38193 15.2991 6.41193 14.7691 6.14193L9.51906 3.52193C8.98906 3.26193 8.13906 3.28193 7.62906 3.57193L3.29906 6.05193C2.73906 6.37193 2.28906 7.15193 2.28906 7.78193Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.55859 4V17",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7305 6.62109V20.0011",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.45478972a4af5de1ee5f86b427ef6bdf.svg";
export { ForwardRef as ReactComponent };